import {Observable} from 'rxjs';
import {palipaliAPI} from '../provider/palipaliAPI';
import {RestQueryParams} from '../base/queryParams';

export function deleteVehicleAPI(authToken: string, currentlyDeletedVehicleId: string): Observable<null> {
    return palipaliAPI.delete(`api/vehicles/${currentlyDeletedVehicleId}`, new RestQueryParams(), {
        Authorization: `Bearer ${authToken}`,
    });
}
